import { BaseApiRepository } from "@/core/infrastructure/BaseApiRepository";
import { LimitControlRepository } from "../domain/repositories/LimitControlRepository";
import {
  LimitControlCreateRequest,
  LimitControlUpdateRequest,
  ResponseDenominators,
  ResponseLimitControl,
  ResponseLimitControlKV,
  ResponseLimitTypes,
  ResponsePortfolio as ResponsePortfolios,
  ResponseSubLimitTypes
} from "../domain/entities/LimitControlEntity";

export class LimitControlApiRepository extends BaseApiRepository implements LimitControlRepository {
  async getAllLimitControls(): Promise<ResponseLimitControlKV> {
    return await this.request<ResponseLimitControlKV>(`/api/limits`);
  }

  async getLimitControlById(id: string): Promise<ResponseLimitControlKV> {
    return await this.request<ResponseLimitControlKV>(`/api/limits/${id}`);
  }

  async createLimitControl(limit: LimitControlCreateRequest): Promise<ResponseLimitControl> {
    const result = await this.request<ResponseLimitControl>("/api/limits", {
      method: "POST",
      body: JSON.stringify(limit),
    });

    await new Promise((r) => setTimeout(r, 2000));
    return result;
  }

  async updateLimitControl(limit: LimitControlUpdateRequest): Promise<ResponseLimitControl> {
    return await this.request<ResponseLimitControl>(`/api/limits/${limit.id}`, {
      method: "PUT",
      body: JSON.stringify(limit),
    });
  }

  async deleteLimitControl(id: string): Promise<ResponseLimitControl> {
    return await this.request<ResponseLimitControl>(`/api/limits/${id}`, {
      method: "DELETE",
    });
  }

  async getAllLimitTypes(): Promise<ResponseLimitTypes> {
    return await this.request<ResponseLimitTypes>("/api/limitTypes");
  }

  async getAllSubLimitTypes(): Promise<ResponseSubLimitTypes> {
    return await this.request<ResponseSubLimitTypes>(`/api/subLimitTypes`);
  }

  async getAllSubLimitTypesByLimitType(id: string): Promise<ResponseSubLimitTypes> {
    return await this.request<ResponseSubLimitTypes>(`/api/subLimitTypes/byLimitType/${id}`);
  }

  async getAllPortfolios(): Promise<ResponsePortfolios> {
    return await this.request<ResponsePortfolios>("/api/portfolios");
  }

  async getAllDenominators(): Promise<ResponseDenominators> {
    return await this.request<ResponseDenominators>("/api/denominators");
  }
}
